import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { S3ACCESSURL } from "../../../databucket";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { Spin, Alert } from "antd";
import { FileTextOutlined } from "@ant-design/icons";

// Required worker setup for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const HandbookViewer = () => {
  const { handbookId } = useParams();
  const employeeHandbooks = useSelector((state) => state?.handbooks?.myHandbooks || []);
  const handbook = employeeHandbooks.find((hb) => hb._id === handbookId);

  const [numPages, setNumPages] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const pdfUrl = handbook?.file?.data ? `${S3ACCESSURL}${handbook.file.data}` : null;

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
    setIsLoading(false);
  }, []);

  const onDocumentLoadError = useCallback(() => {
    setIsLoading(false);
    setHasError(true);
  }, []);

  if (!handbook) {
    return (
      <div className="card profile-box flex-fill">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Alert
              type="warning"
              showIcon
              message="Handbook Not Found"
              description="Please select a valid handbook from the sidebar."
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card profile-box flex-fill">
      <div className="page-wrapper">
        <div className="content container-fluid">

          {/* Header */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
            <FileTextOutlined style={{ fontSize: 24, color: "#1677ff" }} />
            <div>
              <h4 style={{ margin: 0, color: "#1677ff" }}>{handbook.name}</h4>
              {handbook.description && (
                <p style={{ margin: 0, color: "#8c8c8c", fontSize: 13 }}>{handbook.description}</p>
              )}
            </div>
          </div>

          {pdfUrl ? (
            <div
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: 8,
                overflow: "hidden",
                background: "#f5f5f5",
                // Disable user selection to prevent copy
                userSelect: "none",
                WebkitUserSelect: "none",
              }}
              // Block right-click context menu
              onContextMenu={(e) => e.preventDefault()}
            >
              <div style={{
                maxHeight: "75vh",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "20px 0",
                gap: 12,
              }}>
                {isLoading && (
                  <div style={{ padding: 60, display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
                    <Spin size="large" />
                    <span style={{ color: "#8c8c8c", fontSize: 13 }}>Loading PDF...</span>
                  </div>
                )}

                {hasError && (
                  <Alert
                    type="error"
                    message="Failed to load PDF"
                    description="The document could not be displayed."
                    style={{ margin: 20 }}
                  />
                )}

                <Document
                  file={pdfUrl}
                  onLoadSuccess={onDocumentLoadSuccess}
                  onLoadError={onDocumentLoadError}
                  loading={null}
                >
                  {Array.from({ length: numPages || 0 }, (_, i) => (
                    <Page
                      key={`page_${i + 1}`}
                      pageNumber={i + 1}
                      width={Math.min(window.innerWidth * 0.65, 900)}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      style={{ marginBottom: 8 }}
                    />
                  ))}
                </Document>
              </div>
            </div>
          ) : (
            <Alert
              type="info"
              showIcon
              message="No File Available"
              description="This handbook does not have a file attached."
            />
          )}

        </div>
      </div>
    </div>
  );
};

export default HandbookViewer;